import { render } from "./DashboardWallet.vue?vue&type=template&id=2ea7784a&scoped=true&ts=true"
import script from "./DashboardWallet.vue?vue&type=script&lang=ts"
export * from "./DashboardWallet.vue?vue&type=script&lang=ts"

import "./DashboardWallet.vue?vue&type=style&index=0&id=2ea7784a&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea7784a"]])

export default __exports__